import { Row, RowProps } from 'antd';
import styled from 'styled-components';
import { FC } from 'react';
import {devices} from "../../../Theme";

export const FormInputRow: FC<RowProps> = styled(Row)`
  margin-bottom: 20px;
`;
